import {ACTION_CODE} from './_actionCode';
import {ProductionCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_PRODUCTION_CATEGORIES';

export async function getAllProductionCategories(
    userData: UserState["userProfileData"],
    params = '',
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllProductionCategories - Start');

        const getAllProductionCategoriesResult =
            await ProductionCategoryService.getAllProductionCategories(userData, params, page);

        LoggerService.logInfo('Action - getAllProductionCategories - End - Success');

        return ResultModel.newSuccessResult(getAllProductionCategoriesResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllProductionCategories - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
